exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#map[_v-566a123b]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999;background-color:rgba(0,0,0,.2)}.layout[_v-566a123b]{width:830px;margin:80px auto 0;border-radius:3px;overflow:hidden;box-shadow:0 0 5px rgba(0,0,0,.5)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-566a123b&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Map.vue
 ** module id = 121
 ** module chunks = 0
 **/